import React from "react";
import styles from "./styles.module.scss";
import { UIText } from "src/components/uIKit";
import { TEXT_TAGS } from "src/utils/enums";
import { TextElements } from "src/utils/types";

interface WarningBannerProps {
  title: string;
  subTitle: string;
  subTitleSecondPart?: string;
  tag?: TEXT_TAGS;
  ariaLabel?: string;
}

const WarningBanner: React.FC<WarningBannerProps> = ({
  title,
  subTitle,
  subTitleSecondPart,
  tag = TEXT_TAGS.H3,
  ariaLabel,
}) => {
  return (
    <div className={styles.warningBanner}>
      {
        title &&
        <UIText
          text={title}
          size={20}
          tag={tag as TextElements}
          weight={500}
          style={styles.title}
        />
      }

      <UIText ariaLabel={ariaLabel} text={subTitle} size={16} weight={400} style={styles.subtitle} />
      {subTitleSecondPart && (
        <>
          <br />
          <br />
          <UIText
            ariaLabel={ariaLabel}
            text={subTitleSecondPart}
            size={16}
            weight={400}
            style={styles.subtitle}
          />
        </>
      )}
    </div>
  );
};

export default WarningBanner;
